// General
export const GENERAL_LOCALE_SET = 'GENERAL/LOCALE_SET'
export const GENERAL_LOCALE_RESET = 'GENERAL/LOCALE_RESET'
export const GENERAL_UPDATE_TABLE_DATA = 'GENERAL/UPDATE_TABLE_DATA'
export const GENERAL_FETCH_SETTINGS = 'GENERAL/FETCH_SETTINGS'
export const GENERAL_FETCH_POSTS = 'GENERAL/FETCH_POSTS'

// Auth
export const AUTH_LOGOUT = 'AUTH/LOGUT'
export const AUTH_LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS'
export const AUTH_SET_USER = 'AUTH/SET_USER'

// Locations
export const LOCATION_FETCH = 'LOCATION/FETCH'
export const LOCATION_UPDATE = 'LOCATION/UPDATE'
export const LOCATION_ADD = 'LOCATION/ADD'
export const LOCATION_DELETE = 'LOCATION/DELETE'

// Artists
export const ARTIST_FETCH = 'ARTIST/FETCH'
export const ARTIST_UPDATE = 'ARTIST/UPDATE'
export const ARTIST_ADD = 'ARTIST/ADD'
export const ARTIST_DELETE = 'ARTIST/DELETE'

// Artistcategories
export const ARTISTCATEGORIES_FETCH =  'ARTISTCATEGORIES/FETCH'
export const ARTISTCATEGORIES_UPDATE = 'ARTISTCATEGORIES/UPDATE'
export const ARTISTCATEGORIES_ADD =    'ARTISTCATEGORIES/ADD'
export const ARTISTCATEGORIES_DELETE = 'ARTISTCATEGORIES/DELETE'

// Attachments
export const ATTACHMENTS_SET_LIST = 'ATTACHMENT/SET_LIST'
export const ATTACHMENTS_SET_FILTER = 'ATTACHMENT/SET_FILTER'
export const ATTACHMENTS_SET_PAGE = 'ATTACHMENT/SET_PAGE'
export const ATTACHMENTS_SET_LOADING = 'ATTACHMENT/SET_LOADING'

// Tracker
export const TRACKER_SET_BUSES = 'TRACKER/SET_BUSES'
export const TRACKER_SET_ROUTES = 'TRACKER/SET_ROUTES'



// WEBPACK FOOTER //
// ./src/store/mutations.js